import { ACTIVIDAD_RESERVA_DETALLE_SET_DATA } from './types'

import { ActividadReservaDetalle } from '@/common/interfaces/respuestas'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const setARDData = (ard: ActividadReservaDetalle[]) => ({
  type: ACTIVIDAD_RESERVA_DETALLE_SET_DATA,
  payload: ard,
})
